import type { ShipmentType } from '@/apis/cart/cart.interface';
import type { SubscribeStatus, SubscribeType } from '@/apis/outofStock/outofStock.interface';
import { ImageProps } from 'next/image';
import { ReactNode } from 'react';

//商卡类型
export enum ProductType {
  TYPE_1 = '1', //首页楼层商卡
  TYPE_2 = '2', //心愿单、浏览历史、活动落地页（商品池、新品、排行榜）
  TYPE_3 = '3', //搜索、推荐
  TYPE_4 = '4', //店铺
  TYPE_5 = '5', //排行榜
}

//商卡状态
export enum ProductState {
  IN_STOCK = 'inStock', //有货
  PRE_SALE = 'preSale', //预售
  OUT_OF_STICK = 'outOfStock', //无货
  REMOVED = 'removed', //下架
}

//商品图片key传参
export interface SkuImgKeyParams {
  imgUrlKey: string;
  width?: number;
  height?: number;
  quality?: number;
  domains?: string | Array<string>;
}

export enum CartIconColorType {
  RED = 'red',
  BLACK = 'black',
}

export enum PreSellStatus {
  WAIT_RESERVE = 1, //等待预约
  RESERVING = 2, //预约中
  WAIT_PANIC_BUYING = 3, //等待抢购/抽签中
  PANIC_BUYING = 4, //抢购中
  PANIC_BUYING_END = 5, //抢购结束
}

export enum HoverSkuNameColorType {
  RED = 'red',
  BLACK = 'black',
}

//金额组件参数
export interface JDIPriceParams {
  symbol: string;
  price: string;
  symbolStyle?: React.CSSProperties;
  integerStyle?: React.CSSProperties;
  decimalPointStyle?: React.CSSProperties;
  decimalPlaceStyle?: React.CSSProperties;
  lineThrough?: boolean;
  containerStyle?: React.CSSProperties;
  uiType?: number; // 内置ui类型
}

//商图上层标签
export interface imgTipsData {
  position: string; //顶部标签定位位置el: topLeft topRight bottomLeft bottomRight
  tipDom: ReactNode; //标签内容：只提供一个插槽位置，具体标签需要渲染什么东西需要直接传进来
}

export interface moreModelsData {
  imageUrl: string; //展示图片
  wareId: string; //skuId
}

//曝光埋点参数
export interface ExpConfigType {
  event_id?: string;
  config?: any;
  json_param?: any;
  event_param?: any;
}

export interface trackingPointParamsType {
  productExpConfig?: ExpConfigType; //商卡曝光埋点参数
  cartExpConfig?: ExpConfigType; //购物车曝光埋点参数
  wishExpConfig?: ExpConfigType; //心愿单曝光埋点参数
  productClickPoint?: () => void; //点击商卡埋点回调
  cartClickPoint?: () => void; //点击加车埋点回调
  addCartPoint?: () => void; //加车成功埋点参数回调
  wishClickPoint?: (button_state: string) => void; //心愿单点击埋点参数回调（因为点击心愿单按钮数据只在商卡内部更新数据，所以返回当前）
}

//商卡1入参
export interface productData_1 {
  type: ProductType; //商卡类型 1：首页营销；2：feed流、落地页；3：搜索；
  from?: string; //引用商卡来源
  width?: number; //宽度 单位是px(默认240),
  height?: number; //宽度 单位是px(默认240),
  containerStyle?: React.CSSProperties; //组件整体最外层样式
  shouldShowSkuName?: boolean; //是否显示商品名称楼层
  skuName?: string; //商品名称
  skuNameStyle?: React.CSSProperties; //商品名称样式
  saleTipsDom?: ReactNode; //标题标签
  skuImgKeyParams?: SkuImgKeyParams; //商品图片key传参
  skuImg?: string; //商品图片url
  skuImgStyle?: React.CSSProperties; //商品图片样式
  skuId: string; //skuId
  shouldShowPrice?: boolean; //是否显示商品价格楼层
  priceStyle?: React.CSSProperties; //商品价格样式
  realPrice?: string; //商品优惠价格
  realPriceJDIPriceParams?: JDIPriceParams; //商品优惠价格样式
  originalPrice?: string; //商品划线价格
  originalPriceJDIPriceParams?: JDIPriceParams; //划线价样式
  currency?: string; //货币单位
  languageCode?: string; //多语言标识
  imgTips?: imgTipsData; //顶部标签,
  shouldShowCart?: boolean; //是否显示加入购物车按钮
  onClickCart?: (productData: productData_1) => void; //点击加入购物车按钮
  onAddCartSuccess?: (productData: productData_1) => void; //点击加车成功回调
  shouldShowModal?: boolean; //通用加车时是否展示规格弹层(如果传入onClickCart方法则失效)
  shouldShowService?: boolean; //是否展示服务规格弹层（如果shouldShowModal为false，则该值不生效）
  jumpTarget?: string; //跳转方式
  jumpUrl?: string; //跳转链接（用于a标签的渲染使用,如果没有则默认跳转商详，el: /cart ）
  onClickProduct?: (props: any) => void; //点击商卡事件
  shouldShowMarketing?: boolean; //是否显示营销标签
  marketingStyle?: React.CSSProperties; //营销标签样式
  marketingArray?: any[]; //营销标签
  isOutOfStock?: boolean; //是否展示无货
  isRemoved?: boolean; //是否展示下架
  trackingPointParams?: trackingPointParamsType; //埋点参数
  shipmentType?: ShipmentType; //加车透传参数：配送方式 66 配送 or 64 自提
  brandName?: string; //品牌名称
  cartIconColor?: CartIconColorType; //加车按钮类型
  isUnderline?: boolean; //是否展示下划线
  isCartIconGreyHover?: boolean; //是否显示灰色加车按钮划过样式
  hoverSkuNameColor?: HoverSkuNameColorType;
}

//商卡2入参
export interface productData_2 {
  type: ProductType; //商卡类型 1：首页营销；2：feed流、落地页；3：搜索； 4:店铺
  from?: string; //引用商卡来源
  width?: string | number; //宽度 单位是px(默认240),
  height?: string | number; //宽度 单位是px(默认240),
  containerStyle?: React.CSSProperties; //组件整体最外层样式
  skuName: string; //商品名称
  skuNameStyle?: React.CSSProperties; //商品名称样式
  productLabelDom?: ReactNode; //商品名称前的标签，业务预留标签
  titleRightDom?: ReactNode; //商品名称右侧标签，业务预留标签
  saleTipsDom?: ReactNode; //折扣标签
  skuImgKey?: string; //商品图片key
  skuImgKeyParams?: SkuImgKeyParams; //商品图片key传参
  skuImg?: string; //商品图片url
  skuImgStyle?: React.CSSProperties; //商品图片样式
  skuImgProps?: Partial<ImageProps>; // 商卡CDNImage组件的默认属性
  skuId: string; //skuId
  score: string; //评分
  saleNum: string; //销量
  scoreStyle?: React.CSSProperties; //评分样式
  realPrice: string; //商品优惠价格
  realPriceJDIPriceParams?: JDIPriceParams; //商品优惠价格样式
  originalPrice?: string; //商品划线价格
  originalPriceJDIPriceParams?: JDIPriceParams; //划线价样式
  currency?: string; //货币单位
  languageCode?: string; //多语言标识
  imgTips?: imgTipsData; //顶部标签,
  shouldShowCart?: boolean; //是否显示加入购物车按钮
  onClickCart?: (productData: productData_2) => void; //点击加入购物车按钮
  onAddCartSuccess?: (productData: productData_2) => void; //点击加车成功回调
  shouldShowModal?: boolean; //通用加车时是否展示规格弹层(如果传入onClickCart方法则失效)
  shouldShowService?: boolean; //是否展示服务规格弹层（如果shouldShowModal为false，则该值不生效）
  jumpTarget?: string; //跳转方式
  jumpUrl?: string; //跳转链接（用于a标签的渲染使用,如果没有则默认跳转商详，el: /cart ）
  onClickProduct?: (props: any) => void; //点击商卡事件
  marketingStyle_1?: React.CSSProperties; //商品名称下营销标签样式
  marketingArray_1?: any[]; //商品名称下营销标签
  marketingStyle_2?: React.CSSProperties; //底部营销标签样式
  marketingArray_2?: any[]; //底部营销标签
  shouldShowMoreModel?: boolean; //是否展示多规格楼层
  moreModels?: moreModelsData[]; //多规格数据
  moreModelsStyle?: React.CSSProperties; //多规格楼层样式
  isOutOfStock?: boolean; //是否展示无货
  isRemoved?: boolean; //是否展示下架
  promotions?: any[]; //营销标签数组
  saleInfo?: string; //规格信息
  saleInfoStyle?: React.CSSProperties; //规格信息样式
  priceStyle?: React.CSSProperties; //商品价格样式
  trackingPointParams?: trackingPointParamsType; //埋点参数
  subscribeType?: SubscribeType; //订阅类型 0-> 缺货提醒;
  subscribeStatus?: SubscribeStatus; //订阅状态， 1 ->订阅，0 -> 未订阅
  NotifyCallback?: (states: boolean) => void; //订阅回调,返回参数states表示订阅成功或失败
  shipmentType?: ShipmentType; //加车透传参数：配送方式 66 配送 or 64 自提
}

//搜推商卡3入参
export interface productData_3 {
  type: ProductType; //商卡类型 1：首页营销；2：feed流、落地页；3：搜推； 4:店铺
  from?: string; //引用商卡来源
  width?: string | number; //宽度 单位是px(默认240),
  height?: string | number; //宽度 单位是px(默认240),
  containerStyle?: React.CSSProperties; //组件整体最外层样式
  productState: ProductState; //商卡状态：'inStock': 有货；'outOfStock': '无货'；'removed': 商品下架；
  skuName: string; //商品名称
  skuNameStyle?: React.CSSProperties; //商品名称样式
  productLabelDom?: ReactNode; //商品名称前的标签，业务预留标签
  saleTipsDom?: ReactNode; //折扣标签
  skuImgKey?: string; //商品图片key
  skuImgKeyParams?: SkuImgKeyParams; //商品图片key传参
  skuImg?: string; //商品图片url
  skuImgStyle?: React.CSSProperties; //商品图片样式
  skuImgProps?: Partial<ImageProps>; // 商卡CDNImage组件的默认属性
  skuId: string; //skuId
  score: string; //评分
  scoreStyle: React.CSSProperties; //评分样式
  realPrice: string; //商品优惠价格
  realPriceJDIPriceParams?: JDIPriceParams; //商品优惠价格样式
  originalPrice?: string; //商品划线价格
  originalPriceJDIPriceParams?: JDIPriceParams; //划线价样式
  priceStyle?: React.CSSProperties; //商品价格样式
  currency?: string; //货币单位
  languageCode?: string; //多语言标识
  imgTips?: imgTipsData; //顶部标签,
  shouldShowCart?: boolean; //是否显示加入购物车按钮
  onClickCart?: (productData: productData_3) => void; //点击加入购物车按钮
  onAddCartSuccess?: (productData: productData_3) => void; //点击加车成功回调
  shouldShowModal?: boolean; //通用加车时是否展示规格弹层(如果传入onClickCart方法则失效)
  shouldShowService?: boolean; //是否展示服务规格弹层（如果shouldShowModal为false，则该值不生效）
  jumpTarget?: string; //跳转方式
  jumpUrl?: string; //跳转链接（用于a标签的渲染使用,如果没有则默认跳转商详，el: /cart ）
  onClickProduct?: (props: any) => void; //点击商卡事件
  marketingStyle_1?: React.CSSProperties; //商品名称下营销标签样式
  marketingArray_1?: any[]; //商品名称下营销标签
  marketingStyle_2?: React.CSSProperties; //底部营销标签样式
  marketingArray_2?: any[]; //底部营销标签
  shouldShowMoreModel?: boolean; //是否展示多规格楼层
  moreModels?: moreModelsData[]; //多规格数据
  moreModelsStyle?: React.CSSProperties; //多规格楼层样式
  promotions?: any[]; //营销标签数组
  saleInfo?: string; //规格信息
  saleInfoStyle?: React.CSSProperties; //规格信息样式
  trackingPointParams?: trackingPointParamsType; //埋点参数
  subscribeType?: SubscribeType; //订阅类型 0-> 缺货提醒;
  subscribeStatus?: SubscribeStatus; //订阅状态， 1 ->订阅，0 -> 未订阅
  NotifyCallback?: (states: boolean) => void; //订阅回调,返回参数states表示订阅成功或失败
  shipmentType?: ShipmentType; //加车透传参数：配送方式 66 配送 or 64 自提
  isWish?: boolean; //是否已订阅
  isShowWish?: boolean; //是否展示心愿单按钮
  isMember?: boolean; //是否是会员
  memberPrice?: string; //会员价
  memberPriceDesc?: string; //会员价描述
  memberPriceIcon?: string; //会员价图标
  unitPriceText?: string; //单位价格
  //预售信息
  presellInfo?: {
    preSellStatus: PreSellStatus; //预约开始状态 1：等待预约 2：预约中 3：等待抢购/抽签中 4：抢购中 5：抢购结束
    startTimeFormat: string; //Starts at %s   /  开始于 %s
    endTimeFormat: string; //Ends in %s  /  %s 结束
    panicBuyingEndTime: number; // 抢购结束时间秒数  eg：120
    panicBuyingEndTimeStr: string; //抢购开始时间文案 eg：Aug 16, 00:00
    panicBuyingStartTime: number; //抢购开始时间秒数  eg： 60
    panicBuyingStartTimeStr: string; //抢购结束时间  eg: Aug 16, 00:00
    userReserve: boolean; //用户是否预约
    preSellLabels?: string[]; //预约标签富文本
  };
  isPromotion?: boolean; //是否是新人
}

//店铺商卡4入参
export interface productData_4 {
  type: ProductType; //商卡类型 1：首页营销；2：feed流、落地页；3：搜索； 4:店铺;
  from?: string; //引用商卡来源
  width?: number; //宽度 单位是px(默认240),
  height?: number; //宽度 单位是px(默认240),
  containerStyle?: React.CSSProperties; //组件整体最外层样式
  shouldShowSkuName?: boolean; //是否显示商品名称楼层
  skuName: string; //商品名称
  skuNameStyle?: React.CSSProperties; //商品名称样式
  saleTipsDom?: ReactNode; //标题标签
  skuImgKeyParams?: SkuImgKeyParams; //商品图片key传参
  skuImg?: string; //商品图片url
  skuImgStyle?: React.CSSProperties; //商品图片样式
  skuId: string; //skuId
  score: string; //评分
  scoreStyle: React.CSSProperties; //评分样式
  saleNum: string; //评分
  saleNumStyle: React.CSSProperties; //评分样式
  shouldShowPrice?: boolean; //是否显示商品价格楼层
  priceStyle?: React.CSSProperties; //商品价格样式
  realPrice: string; //商品优惠价格
  realPriceJDIPriceParams?: JDIPriceParams; //商品优惠价格样式
  originalPrice?: string; //商品划线价格
  originalPriceJDIPriceParams?: JDIPriceParams; //划线价样式
  currency?: string; //货币单位
  languageCode?: string; //多语言标识
  imgTips?: imgTipsData; //顶部标签,
  shouldShowCart?: boolean; //是否显示加入购物车按钮
  onClickCart?: (productData: productData_4) => void; //点击加入购物车按钮
  onAddCartSuccess?: (productData: productData_4) => void; //点击加车成功回调
  shouldShowModal?: boolean; //通用加车时是否展示规格弹层(如果传入onClickCart方法则失效)
  shouldShowService?: boolean; //是否展示服务规格弹层（如果shouldShowModal为false，则该值不生效）
  jumpTarget?: string; //跳转方式
  jumpUrl?: string; //跳转链接（用于a标签的渲染使用,如果没有则默认跳转商详，el: /cart ）
  onClickProduct?: (props: any) => void; //点击商卡事件
  shouldShowMarketing?: boolean; //是否显示营销标签
  marketingStyle?: React.CSSProperties; //营销标签样式
  marketingArray?: any[]; //营销标签
  isOutOfStock?: boolean; //是否展示无货
  isRemoved?: boolean; //是否展示下架
  trackingPointParams?: trackingPointParamsType; //埋点参数
  shipmentType?: ShipmentType; //加车透传参数：配送方式 66 配送 or 64 自提
}

//Best sellers 商卡5入参
export interface productData_5 {
  type: ProductType; //商卡类型 1：首页营销；2：feed流、落地页；3：搜推； 4:店铺  5:Best sellers
  width?: string | number; //宽度 单位是px(默认240),
  height?: string | number; //宽度 单位是px(默认240),
  containerStyle?: React.CSSProperties; //组件整体最外层样式
  productState: ProductState; //商卡状态：'inStock': 有货；'outOfStock': '无货'；'removed': 商品下架；
  skuName: string; //商品名称
  skuNameStyle?: React.CSSProperties; //商品名称样式
  skuImgKeyParams?: SkuImgKeyParams; //商品图片key传参
  skuImg?: string; //商品图片url
  skuImgStyle?: React.CSSProperties; //商品图片样式
  skuImgProps?: Partial<ImageProps>; // 商卡CDNImage组件的默认属性
  skuId: string; //skuId
  realPrice: string; //商品优惠价格
  realPriceJDIPriceParams?: JDIPriceParams; //商品优惠价格样式
  originalPrice?: string; //商品划线价格
  originalPriceJDIPriceParams?: JDIPriceParams; //划线价样式
  priceStyle?: React.CSSProperties; //商品价格样式
  currency?: string; //货币单位
  languageCode?: string; //多语言标识
  imgTips?: imgTipsData; //顶部标签,
  shouldShowCart?: boolean; //是否显示加入购物车按钮
  onClickCart?: (productData: productData_5) => void; //点击加入购物车按钮
  onAddCartSuccess?: (productData: productData_5) => void; //点击加车成功回调
  shouldShowModal?: boolean; //通用加车时是否展示规格弹层(如果传入onClickCart方法则失效)
  shouldShowService?: boolean; //是否展示服务规格弹层（如果shouldShowModal为false，则该值不生效）
  jumpTarget?: string; //跳转方式
  jumpUrl?: string; //跳转链接（用于a标签的渲染使用,如果没有则默认跳转商详，el: /cart ）
  onClickProduct?: (props: any) => void; //点击商卡事件
  marketingStyle_2?: React.CSSProperties; //底部营销标签样式
  marketingArray_2?: any[]; //底部营销标签
  promotions?: any[]; //营销标签数组
  trackingPointParams?: trackingPointParamsType; //埋点参数
  subscribeType?: SubscribeType; //订阅类型 0-> 缺货提醒;
  subscribeStatus?: SubscribeStatus; //订阅状态， 1 ->订阅，0 -> 未订阅
  NotifyCallback?: (states: boolean) => void; //订阅回调,返回参数states表示订阅成功或失败
  shipmentType?: ShipmentType; //加车透传参数：配送方式 66 配送 or 64 自提
  isWish?: boolean; //是否已订阅
  viewedTip?: string; //已浏览提示
  brandName?: string; //品牌
}
